import React from 'react';

import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';

import { FormFieldPropType } from 'components/modules/custom-pages/types/form-block.types';

import './FormFieldLocationSelectOptions.scss';

const propTypes = {
  field: FormFieldPropType.isRequired,
  onUpdateFieldValue: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function FormFieldLocationSelectOptions({ field, onUpdateFieldValue }) {
  const { settings = {} } = field;
  const { sendEmailToSelectedLocation } = settings;

  function onSendEmailToSelectedLocationChange(e, { checked }) {
    onUpdateFieldValue('settings.sendEmailToSelectedLocation', checked);
  }

  return (
    <div className="form-field-location-select-options">
      <div>Options</div>
      <Checkbox
        toggle
        label="Send email to selected location"
        checked={sendEmailToSelectedLocation}
        onChange={onSendEmailToSelectedLocationChange}
      />
    </div>
  );
}

FormFieldLocationSelectOptions.propTypes = propTypes;
FormFieldLocationSelectOptions.defaultProps = defaultProps;
